// src/data/menu/index.js
// Anchor hrefs must match the section ids rendered by PublicHome.
// Add { id: 6, title: 'Schedule Demo', href: '#demo' } once the Demo
// section is ported over from busline.
const Menudata = [
  {
    id: 1,
    title: 'Home',
    href: '#home',
  },
  {
    id: 2,
    title: 'Service',
    href: '#service',
  },
  {
    id: 3,
    title: 'Learn More',
    href: '#preview',
  },
  {
    id: 4,
    title: 'Products',
    href: '#products',
  },
  {
    id: 5,
    title: 'Sign Up',
    href: '#signup',
  },
  {
    id: 7,
    title: 'Contact',
    href: '#contact',
  },
];

export default Menudata;
